import { boundError } from './min-max'

export const conditionByType = (type) => {
    switch (type) {
        case 'req':
            return function (f, value) {return (f.required && (value == null || value.length === 0))}
        case 'bound':
            return function (f,value) {return boundError(f, value)}
        case 'all':
            return function (f,value) {return (f.required && (!value || ('' + value).length === 0)) || boundError(f, value)}
    }
}